import { Tile } from '@fdc/components/ui/article-tile/tile';
import { Carousel } from '@fdc/components/ui/carousel/carousel';
import { ITile } from '@fdc/types/tiles-model';
import { useWindowDimension } from '@woolworthslimited/core-components-react/shared/hooks/useWindowDimension';

import { isSmallDeviceOrGreater } from '@contentservice/shared/services/breakpoint/breakpoint.service';

import { ArticleTileListProps } from './article-tile-list-model';
import styles from './article-tile-list.module.scss';

export const ArticleTiles = ({ items, sectionId }: ArticleTileListProps) => {
  const [width] = useWindowDimension(false);
  const isDesktop = isSmallDeviceOrGreater(width);

  if (isDesktop) {
    return (
      <section className={styles.articleTileList} id={sectionId}>
        <div className={styles.tiles}>
          {items.map((tile: ITile, i: number) => (
            <Tile
              key={tile.heading + i}
              imageAlt={tile.imageAlt}
              imgUrl={tile.imgUrl}
              imgAriaLabel={tile.imgAriaLabel}
              heading={tile.heading}
              paragraph1={tile.paragraph1}
              btnText={tile.btnText}
              btnAltText={tile.btnAltText}
              btnClickHandler={tile.btnClickHandler}
              imgClickHandler={tile.imgClickHandler}
            />
          ))}
        </div>
      </section>
    );
  } else {
    return (
      <section className={styles.articleTileListMobile} id={sectionId}>
        <Carousel>
          {items.map((tile: ITile, i: number) => (
            <Tile key={tile.heading + i} {...tile} isDesktopView={false}></Tile>
          ))}
        </Carousel>
      </section>
    );
  }
};
